let token = '';

export const getToken = (): string => {
    return token;
}

export const setToken = (t: string) => {
    token = t;
}
